import React, { useState, useCallback } from 'react';
import './ScreenDisplay.css';

export default function ScreenDisplay({ color, name, textColor = '#000', hex = '#ffffff' }) {
  
  const [customColor, setCustomColor] = useState(hex);
  const [appliedColor, setAppliedColor] = useState(hex);
  const [brightness, setBrightness] = useState(100);
  const [resolution, setResolution] = useState('1920x1080');
  const [customW, setCustomW] = useState('1920');
  const [customH, setCustomH] = useState('1080');

  const enterFullscreen = useCallback(() => {
    const el = document.getElementById('screen-preview');
    if (el) {
      if (el.requestFullscreen) el.requestFullscreen();
      else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
    }
    
  }, []);

  const handleApply = () => { setAppliedColor(customColor); };

  return (
    <div className="screen-tool">
      {/* Preview */}
      <div className="preview-wrap">
        <div
          id="screen-preview"
          className="screen-preview"
          style={{ background: appliedColor, filter: `brightness(${brightness}%)` }}
          onDoubleClick={enterFullscreen}
        >
          <button className="fs-hint-btn" onClick={enterFullscreen} title="Go fullscreen">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/></svg>
            Fullscreen
          </button>
        </div>
        <p className="preview-hint">Double-click preview or press button to go fullscreen • Press <kbd>Esc</kbd> to exit</p>
      </div>

      {/* Controls panel */}
      <div className="controls-panel">
        <h3 className="controls-title">⚙ Controls</h3>

        <div className="control-section">
          <label className="ctrl-label">Quick Actions</label>
          <div className="quick-btns">
            <button className="qbtn" onClick={enterFullscreen}>⛶ Fullscreen</button>
          </div>
          <label className="ctrl-check">
            <input type="checkbox" /> Open on White Screen
          </label>
        </div>

        <div className="control-section">
          <label className="ctrl-label">Screen Color</label>
          <div className="color-input-row">
            <input type="color" value={customColor} onChange={e => setCustomColor(e.target.value)} className="color-picker" />
            <input type="text" value={customColor} onChange={e => setCustomColor(e.target.value)} className="color-text" placeholder="#ffffff" />
          </div>
          <button className="apply-btn" onClick={handleApply}>Apply Color</button>
        </div>

        <div className="control-section">
          <label className="ctrl-label">Brightness</label>
          <div className="slider-row">
            <input type="range" min="10" max="100" value={brightness}
              onChange={e => setBrightness(e.target.value)} className="slider" />
            <span className="slider-val">{brightness}%</span>
          </div>
        </div>

        <div className="control-section">
          <label className="ctrl-label">Resolution</label>
          <select className="ctrl-select" value={resolution} onChange={e => setResolution(e.target.value)}>
            <option>1920x1080</option>
            <option>2560x1440</option>
            <option>3840x2160</option>
            <option>1280x720</option>
            <option>Custom</option>
          </select>
          {resolution === 'Custom' && (
            <div className="custom-res">
              <input type="number" value={customW} onChange={e => setCustomW(e.target.value)} className="res-input" placeholder="W" />
              <span>×</span>
              <input type="number" value={customH} onChange={e => setCustomH(e.target.value)} className="res-input" placeholder="H" />
            </div>
          )}
        </div>

        <button className="download-btn" onClick={enterFullscreen}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          Download
        </button>

        <div className="color-info-box">
          <span className="cib-label">Current Color:</span>
          <span className="cib-value">{appliedColor.toUpperCase()}</span>
          <span className="cib-swatch" style={{ background: appliedColor, border: appliedColor === '#ffffff' ? '1px solid #e5e7eb' : 'none' }} />
        </div>
      </div>
    </div>
  );
}
